import React, { useState } from 'react';
import { getAuth } from 'firebase/auth';
// If you plan to use callable functions here, you could import { functions } from your centralized firebaseConfig.
// For now, since you're using fetch to call the updatePassword HTTP endpoint, we don't need getFunctions.

const CreateBrokerUser = () => {
  const [email, setEmail] = useState('');
  const [tempPassword, setTempPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleCreateUser = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    try {
      // Call the updatePassword HTTP endpoint
      const response = await fetch('https://us-central1-abc-quote.cloudfunctions.net/updatePassword', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${await getToken()}`,
        },
        body: JSON.stringify({ email, password: tempPassword }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to update password');
      }

      setMessage(`Temporary password set for ${email}.`);
    } catch (err) {
      console.error('Error updating user password:', err);
      setError('Error setting up temporary password. Please check the email and try again.');
    }
  };

  return (
    <div>
      <h2>Create Broker User</h2>
      <form onSubmit={handleCreateUser}>
        <div>
          <label>Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Temporary Password:</label>
          <input
            type="password"
            value={tempPassword}
            onChange={(e) => setTempPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit">Create User</button>
      </form>
      {message && <p>{message}</p>}
      {error && <p>{error}</p>}
    </div>
  );
};

async function getToken() {
  const auth = getAuth();
  const user = auth.currentUser;
  if (user) {
    return user.getIdToken();
  }
  throw new Error('User not authenticated');
}

export default CreateBrokerUser;
